import React, { useState, useRef, useEffect } from "react";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import Typography from "@material-ui/core/Typography";
import CssBaseline from "@material-ui/core/CssBaseline";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import PrintIcon from "@material-ui/icons/Print";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import HomeIcon from "@material-ui/icons/Home";
import Grid from "@material-ui/core/Grid";
import { useStylesSpDial } from "../../../St/Reviews/UseStyle";
import ShareIcon from "@material-ui/icons/Share";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import { handleDownloadGenratePdf, shareDataPdf } from "../ShareFunctionsPrint";
import InvoiceCashiarCon from "./InvoiceCashiarCon";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

class ComponentToPrint extends React.Component {
    state = {
        pwca: true,
    }

    constructor() {
        super();

    }
    render() {
        const premiApp = JSON.parse(localStorage.getItem('premiApp')) || {};

        const styleCont = {
            backgroundColor: '#fff',
        };

        const styleTyg = {
            backgroundColor: '#fff',
            color: '#000',
            padding: '0.2mm'
        };

        return (
            <Grid item container justifyContent='center' style={styleCont}>
                <Grid item
                    style={{
                        width: premiApp.cachirWidth < 55 ? "58mm" : `${premiApp.cachirWidth}mm`,
                        backgroundColor: '#fff'
                    }}
                >
                    <CssBaseline />
                    <Typography component="div" style={styleTyg}>
                        <InvoiceCashiarCon typeInv={this.props.typeInv}
                            locInv={this.props.locInv} onUnmountComplete={this.props.onUnmountComplete} premiApp={premiApp}
                            foundData={this.props.foundData} setFoundData={this.props.setFoundData}/>
                    </Typography>
                </Grid>
            </Grid>

        );
    }
}
const InvoiceCashirPrint = (props) => {
    const { typeInv, locInv, handNewInv ,keepFocus,isFocus,foundData,setFoundData} = props;
    const componentRef = useRef();
    const reportDownloadRef = useRef();
    const clasSp = useStylesSpDial();

    const [open, setOpen] = useState(true);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(true);
    };
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        onAfterPrint: () => handNewInv(),
    });
    const [childMountCount, setChildMountCount] = useState(0);
    const handleChildMountComplete = () => {
        setChildMountCount((prevCount) => prevCount + 1);
    };
    const docNamePdf ="Invoice.pdf";
    const docName = "Invoice";
    let his = useHistory();

    const back = async(path) => {  
        if(path==true){
            his.push({ pathname: "/" });
        }else{
            if(isFocus){try{ await keepFocus();}catch{}} 
            await handNewInv();
        }
    };
    const shareData = async () => {
        shareDataPdf(reportDownloadRef, docNamePdf);
    };
    const handleGeneratePdf = async () => {
        handleDownloadGenratePdf(docName, reportDownloadRef)
    };

    useEffect(() => {
        if (childMountCount === 3 &&  typeInv === 2) {
          setTimeout(async () => {
            handlePrint();
          }, 500);
        }
      }, [childMountCount]);
    const actions = [
        { icon: <ReactToPrint trigger={() => <PrintIcon /> } content={() => componentRef.current} />, name: 'طباعـة' },
        {
            icon: (
                <ArrowDownward className={clasSp.ico} onClick={handleGeneratePdf} />
            ),
            name: "تنزيل",
        },
        {
            icon: <ShareIcon className={clasSp.ico} onClick={shareData} />,
            name: "مشاركة",
        },
        {
            icon: (
                <ArrowBackIcon className={clasSp.ico} onClick={() => back(false)} />
            ),
            name: "رجـوع",
        },
    ];

    return (
        <div className={clasSp.root}
        dir={'rtl'} lang={'ar'} style={{fontFamily: 'Amiri-Regular', 
            fontStyle:"normal", letterSpacing:'normal'}}>
            <div
                ref={reportDownloadRef}
                lang={"ar"}
                style={{
                    fontFamily: "Helvetica",
                    fontStyle: "bold",
                    letterSpacing: "normal",
                }}
            >
                <ComponentToPrint
                    ref={componentRef}
                    onUnmountComplete={handleChildMountComplete}
                    typeInv={typeInv}
                   locInv={locInv}
                   foundData={foundData}setFoundData={setFoundData}
                />
            </div>
            <SpeedDial
                ariaLabel="SpeedDial openIcon example"
                className={clasSp.speedDial}
                hidden={false}
                icon={
                    <SpeedDialIcon openIcon={<HomeIcon />} onClick={() => back(true)} />
                }
                onClose={handleClose}
                onOpen={handleOpen}
                open={open}
            >
                {actions.filter(action => !action.hidden).map((action, i) => (
                    <SpeedDialAction
                        key={i}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={handleClose}
                    />
                ))}
            </SpeedDial>
        </div>
    );
};

export default InvoiceCashirPrint;
